import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import { useAuth } from "../auth/AuthContext";
import Footer from "../../core/common/footer/Footer";

const ALLRoutes: React.FC = () => {
  // const token = Cookies.get("token") || localStorage.getItem("token");

  // const isAuthenticated = !!token;
  // console.log(isAuthenticated, "chekc auth");

  const { isAuthenticated } = useAuth();
  return (
    <>
      <Routes>
        {isAuthenticated ? (
          <Route element={<Feature />}>
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            {publicRoutes.map((route, idx) => (
              <Route
                key={idx}
                path={route.path}
                element={<Navigate to="/login" />}
              />
            ))}
          </>
        )}
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ALLRoutes;
